<script>
  import parallax from 'vue-parallaxy'
  export default {
    components: {
       parallax
    },
    props: {
      title: {
        type: String,
        required: true
      },
      content: {
        type: String,
        default: '',
      },
      image: {
        type: String,
        default: null,
      },
    },
    computed: {

    },
    methods: {
      nlToBr(string) {
        return string && string.replace(/(?:\r\n|\r|\n)/g, '<br>')
      },
    }
  }
</script>
<template>
  <div
    :class="[
      $style.banner,
    ]"
  >
    <parallax
      section-class="banner__parallax"
      :speed-factor="0.2"
    >
      <img
        alt=""
        :src="image || require('@assets/images/about/banner@2.jpg')"
        class="banner__bannerImg"
      >
    </parallax>
    <div class="container h-100 position-relative bannerFixed">
      <div class="banner__bannerBox d-flex h-100">
        <div class="banner__bannerInner color-white d-flex flex-column justify-content-center">
          <BaseDecoration class="mb-5 d-md-block d-none"/>
          <h2 class="banner__bannerTitle font-medium">
            {{ title }}
          </h2>
          <div 
            class="banner__bannerContent" 
            v-html="nlToBr(content)">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss" module>
  .banner {
    min-height: 350px;
    overflow: hidden;
    position: relative;
    z-index: 1;
    @include max-md {
      min-height: 250px;
    }
    :global {
      .banner {
        &__parallax {
          pointer-events: none;
          height: 100% !important;
          position: absolute;
          top: 0;
          right: 0;
          bottom: 0;
          left: 0;
          z-index: -1;
          &::before {
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            content: '';
            background: transparent linear-gradient(90deg, rgba(38, 38, 38, 0.9) 0%, rgba(38, 38, 38, 0) 72%, rgba(110, 110, 110, 0) 100%, rgba(0, 0, 0, 1) 100%) 0% 0% no-repeat padding-box;
            opacity: 0.75;
            z-index: 1;
          }
        }
        // &__bg {
        //   pointer-events: none;
        //   height: 100% !important;
        //   position: absolute;
        //   top: 0;
        //   right: 0;
        //   bottom: 0;
        //   left: 0;
        //   background-color: $color-primary;
        // }
        .bannerBox {
          
        }
        &__bannerImg {
          // height: 500px !important;
        }
        &__bannerTitle {
          font-size: 2.5rem;
          @include max-md {
            font-size: 1.875rem;
          }
        }
        &__bannerInner {
          padding: 5.3rem 0;
          @include max-md {
            padding: 3rem 0;
          }
        }
        &__bannerContent {
          font-size: 1.25rem;
          margin-top: 1.5rem;
          line-height: 1.75;
          @include max-md {
            font-size: 1rem;
          }
        }
      }
    }
  }
</style>
